var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataSortingAlphabeticalAscending = function SvgDataSortingAlphabeticalAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 2 4 10h2l.365-1h2.266L9 10h2L8.2 2zM16 2v16h-3l4 4 4-4h-3V2zM7.547 5.264 8.067 7H6.933zM4 13v2h4l-4 4.563V21h7v-2H7l4-4.58V13z"
  })));
};
export default SvgDataSortingAlphabeticalAscending;